import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { DocumentConfiguration } from '@models/index.model';

@Injectable({
  providedIn: 'root',
})
export class DocumentConfigurationService {
  // Define the subject
  private _configurationChangeSubject: BehaviorSubject<DocumentConfiguration> = new BehaviorSubject(
    {} as DocumentConfiguration
  );

  // Method for updating the subject
  public updateConfiguration(config: DocumentConfiguration): void {
    this._configurationChangeSubject.next(config);
  }

  public configurationChange$(): Observable<DocumentConfiguration> {
    return this._configurationChangeSubject.asObservable();
  }
}
